import { render } from "./KeyPermissionTable.vue?vue&type=template&id=41f2f27a&scoped=true"
import script from "./KeyPermissionTable.vue?vue&type=script&lang=js"
export * from "./KeyPermissionTable.vue?vue&type=script&lang=js"

import "./KeyPermissionTable.vue?vue&type=style&index=0&id=41f2f27a&lang=scss&scoped=true"
import "./KeyPermissionTable.vue?vue&type=style&index=1&id=41f2f27a&lang=scss"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f2f27a"]])

export default __exports__